export function createSingleFlightLoader<T>() {
  let generation = 0
  let pending: Promise<T> | undefined

  const load = (request: () => Promise<T>, apply: (value: T) => void): Promise<T> => {
    if (pending) return pending
    const requestGeneration = generation
    const current = Promise.resolve()
      .then(request)
      .then((value) => {
        if (requestGeneration === generation) apply(value)
        return value
      })
      .finally(() => {
        if (pending === current) pending = undefined
      })
    pending = current
    return current
  }

  const reset = () => {
    generation += 1
    pending = undefined
  }

  return { load, reset }
}
